import {Injectable} from '@angular/core';
declare var $: any;

@Injectable()
export class SettingsService {

  private app: any;
  public layout: any;

  constructor() {
    this.app = {
      url: 'https://topup-casino.api-hub.com:2211'
      // url: 'http://localhost:22110'
    };
  }

  getAppSetting(name: string) {
    return name ? this.app[name] : this.app;
  }

  setAppSetting(name: string, value: string) {
    if (typeof this.app[name] !== 'undefined') {
      this.app[name] = value;
    }
  }

  getPosition() {
    return JSON.parse(localStorage.getItem('profile')).position;
  }

  getProfile() {
    return JSON.parse(localStorage.getItem('profile'));
  }
}



// WEBPACK FOOTER //
// /Users/pakornduangtrakan/Snocko/other/backend-auto/src/app/_services/settings.service.ts